import { render, staticRenderFns } from "./knowledgeCollection.vue?vue&type=template&id=569d3628&scoped=true"
import script from "./knowledgeCollection.vue?vue&type=script&lang=js"
export * from "./knowledgeCollection.vue?vue&type=script&lang=js"
import style0 from "./knowledgeCollection.vue?vue&type=style&index=0&id=569d3628&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d3628",
  null
  
)

export default component.exports